module.exports = __webpack_public_path__ + "img/icon-yun-jin.9d70e739.webp";